import React from 'react'
import dayjs from 'dayjs'
import { connectRange } from 'react-instantsearch-dom'

import MenuItem from '../../atoms/Dropdown/MenuItem'
import Button from '../../atoms/Button/Button'

import Dropdown from '../Dropdown'

const MoveInDropdown = ({ currentRefinement, min, max, refine }) => {
  const today = dayjs().startOf('day')
  const options = [
    {
      label: 'Show All',
      min,
      max,
    },
    {
      label: 'Next 7 Days',
      min,
      max: Math.min(max, dayjs(today).add(7, 'day')),
    },
    {
      label: 'Next 30 Days',
      min,
      max: Math.min(max, dayjs(today).add(30, 'day')),
    },
    {
      label: 'More Than 30 Days',
      min: Math.min(max, dayjs(today).add(30, 'day')),
      max,
    },
  ]

  const active = options.findIndex(
    option => option.min === currentRefinement.min && option.max === currentRefinement.max,
  )

  return (
    <Dropdown selected={options[active].label}>
      {options.map((option, i) => (
        <MenuItem key={i} active={active === i}>
          <Button onClick={() => refine(option)}>{option.label}</Button>
        </MenuItem>
      ))}
    </Dropdown>
  )
}

export default connectRange(MoveInDropdown)
